// extracted by mini-css-extract-plugin
export default {"content":"CommentHistoryView-module__content--lxA6I"};